<template>
  <div class="container">
    <h1>Zahlungsmethode für zukünftige Bestellungen speichern</h1>
    <div>Email-Adresse: {{ customer }}</div>
    <b-button :disabled="inProgress" @click="redirectToStripe">Zahlungsmethode auf Stripe hinterlegen</b-button>
  </div>
</template>

<script>

import buyer from "@/api/buyer";

export default {
  name: 'Save Payment',
  data: () => ({
    inProgress: false
  }),
  computed: {
    customer () {
      return this.$route.query.customer
    }
  },
  methods: {
    async redirectToStripe() {
      try {
        const data = await buyer.createStripeSession(this.customer).then(r => r.data)
        window.location = data.url
      } catch (error) {
          const message = error.response.data
          this.$bvToast.toast(message, {variant: 'danger', title: "Error"})
      } finally {
        this.inProgress = false
      }
    }
  }
}
</script>